import type { InputHTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-check{display:inline-flex;align-items:center;gap:9px;font-family:var(--font-sans);font-size:var(--text-body);color:var(--text-body);cursor:pointer;user-select:none}
.js-check input{position:absolute;opacity:0;width:0;height:0}
.js-check__box{
  width:20px;height:20px;border-radius:6px;border:1.5px solid var(--border-strong);
  background:var(--surface-card);display:flex;align-items:center;justify-content:center;
  color:#fff;flex:none;transition:background var(--dur-fast) var(--ease-out),border-color var(--dur-fast) var(--ease-out),transform var(--dur-fast) var(--ease-spring);
}
.js-check__box svg{width:13px;height:13px;opacity:0;transform:scale(.6);transition:opacity var(--dur-fast),transform var(--dur-fast) var(--ease-spring)}
.js-check:hover .js-check__box{border-color:var(--brand)}
.js-check input:checked + .js-check__box{background:var(--brand);border-color:var(--brand)}
.js-check input:checked + .js-check__box svg{opacity:1;transform:scale(1)}
.js-check input:focus-visible + .js-check__box{box-shadow:var(--ring-brand)}
.js-check input:disabled + .js-check__box{background:var(--neutral-100);border-color:var(--border-default)}
.js-check--disabled{opacity:.55;cursor:not-allowed}
`;

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
}

export function Checkbox({ label, checked, defaultChecked, disabled, className = "", ...rest }: CheckboxProps) {
  injectCss("js-check-css", CSS);
  return (
    <label className={["js-check", disabled ? "js-check--disabled" : "", className].filter(Boolean).join(" ")}>
      <input type="checkbox" checked={checked} defaultChecked={defaultChecked} disabled={disabled} {...rest} />
      <span className="js-check__box">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </span>
      {label && <span>{label}</span>}
    </label>
  );
}
